<video controls autoplay  (ended)="onVideoEnd()" (playing)="onVideoStart()">
    <source src="{{environment.staticUrl}}/welcome-video.mp4" type="video/mp4" />
</video>